import {connect} from 'react-redux';
import {Fields} from 'report-components'
import {updateReportField, addReportField, deleteReportField, updateReportFieldsOrder, autoSaveOrder, autoSaveRemove, autoSaveUpdate} from 'report-components/lib/reducers';
import {getNewId,getItems,makeMapStateToProps} from 'report-components/lib/selectors'

const autoSaveType = {type: 'reportField'}

export const ReportFields = connect(
  makeMapStateToProps({getNewId, getItems})(({getNewId, getItems}) => ({report}) =>
    ({
      fields: getItems(report.reportFields),
      newId: getNewId(report.reportFields),
      labels: report.templates.fieldsLabels
    })),
  dispatch => ({
    addNew: (field, index) => dispatch(addReportField(field, {index})),
    deleteField: (id) => dispatch(deleteReportField(id)),
    updateOrder: (newOrder) => {
      dispatch(updateReportFieldsOrder(newOrder))
      dispatch(autoSaveOrder(newOrder, autoSaveType))
    },
    updateItem: (item) => dispatch(updateReportField(item)),
    removeItem: (id) => dispatch(deleteReportField(id)),
    confirmRemoveItem: (id) => dispatch(autoSaveRemove(id, autoSaveType)),
    autoSaveUpdate: (item) => dispatch(autoSaveUpdate(item, autoSaveType))
  })
)(Fields)



// WEBPACK FOOTER //
// ./src/javascripts/report/ReportFields.jsx